// extracted by mini-css-extract-plugin
module.exports = {"Person":"Person_Person__2_l3Y"};